import { OfflineStorage } from "../libs/estrylib";
/**
 * Auth User Reducers
 */
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  SET_AGENCY_BALANCE,
  SET_AGENCY_CREDIT,
  SET_AGENCY_INFO,
  SET_AGENCY_PERCENTAGE,
  SET_AGENCY_PROFIT,
  SET_USER_UI_STATE_DATA,
  SET_USER_UI_STATE_SECTION_COLUMNS,
} from "../actions/types";
import { OfflineStorageKeyAllowAutoRefresh } from "../libs";

/**
 * initial auth user
 */
const INIT_STATE = {
  user: {
    name: OfflineStorage.instance.get("esitqapp-name"),
    email: OfflineStorage.instance.get("esitqapp-email"),
    permissions: OfflineStorage.instance.get("esitqapp-permissions"),
    profile_picture: OfflineStorage.instance.get("esitqapp-profile-picture"),
    root_agency_logo: OfflineStorage.instance.get("esitqapp-root-agency-logo"),
    agency_logo: OfflineStorage.instance.get("esitqapp-agency-logo"),
    lang: OfflineStorage.instance.get("esitqapp-lang"),
    access_token: OfflineStorage.instance.get("esitqapp-access-token"),
    subdomain: OfflineStorage.instance.get("esitqapp-subdomain"),
    server_date: OfflineStorage.instance.get("esitqapp-server-date"),
    default_permissions: OfflineStorage.instance.get(
      "esitqapp-default-permissions"
    ),
    is_root_agency: OfflineStorage.instance.get("esitqapp-is-root-agency"),
    user_id: OfflineStorage.instance.get("esitqapp-user-id"),
    agency_id: OfflineStorage.instance.get("esitqapp-agency-id"),
    agency_balance: OfflineStorage.instance.get("esitqapp-agency-balance"),
    agency_credit: OfflineStorage.instance.get("esitqapp-agency-credit"),
    agency_profit: OfflineStorage.instance.get("esitqapp-agency-profit"),
    agency_percentage: OfflineStorage.instance.get(
      "esitqapp-agency-percentage"
    ),
    agency_approved_health: OfflineStorage.instance.get(
      "esitqapp-agency-approved-health"
    ),
    agency_approved_travel: OfflineStorage.instance.get(
      "esitqapp-agency-approved-travel"
    ),
    agency_waitingpricing_kasko: OfflineStorage.instance.get(
      "esitqapp-agency-waitingpricing-kasko"
    ),
    agency_waitingpricing_traffic: OfflineStorage.instance.get(
      "esitqapp-agency-waitingpricing-traffic"
    ),
    agency_waitingpricing_dask: OfflineStorage.instance.get(
      "esitqapp-agency-waitingpricing-dask"
    ),
    agency_priceset_kasko: OfflineStorage.instance.get(
      "esitqapp-agency-priceset-kasko"
    ),
    agency_priceset_traffic: OfflineStorage.instance.get(
      "esitqapp-agency-priceset-traffic"
    ),
    agency_priceset_dask: OfflineStorage.instance.get(
      "esitqapp-agency-priceset-dask"
    ),
    max_discount: OfflineStorage.instance.get("esitqapp-max-discount"),
    system_currency: OfflineStorage.instance.get("esitqapp-system-currency"),
    can_do_minus_sales: OfflineStorage.instance.get(
      "esitqapp-can-do-minus-sales"
    ),
    is_debt_ok: OfflineStorage.instance.get("esitqapp-is-debt-ok"),
    max_inactivity_duration: OfflineStorage.instance.get(
      "esitqapp-max-inactivity-duration"
    ),
    live_chat_id: OfflineStorage.instance.get("esitqapp-livechat-id"),
    is_super_admin: OfflineStorage.instance.get("esitqapp-is-super-admin"),
    can_see_super_admin_dashboard: OfflineStorage.instance.get(
      "esitqapp-can-see-super-admin-dashboard"
    ),
    ui_state_data: OfflineStorage.instance.get("esitqapp-uistatedata"),
    has_credit_card: OfflineStorage.instance.get("esitqapp-has-credit-card"),
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state };
    case LOGIN_USER_SUCCESS:
      const user = action.payload;
      user.access_token = user.token_type + " " + user.access_token;
      OfflineStorage.instance.set(OfflineStorageKeyAllowAutoRefresh, true);
      OfflineStorage.instance.set("esitqapp-name", user.name);
      OfflineStorage.instance.set("esitqapp-email", user.email);
      OfflineStorage.instance.set("esitqapp-permissions", user.permissions);
      OfflineStorage.instance.set(
        "esitqapp-profile-picture",
        user.profile_picture
      );
      OfflineStorage.instance.set("esitqapp-agency-logo", user.agency_logo);
      OfflineStorage.instance.set(
        "esitqapp-root-agency-logo",
        user.root_agency_logo
      );
      OfflineStorage.instance.set("esitqapp-lang", user.lang);
      OfflineStorage.instance.set("esitqapp-access-token", user.access_token);
      OfflineStorage.instance.set("esitqapp-server-date", user.server_date);
      OfflineStorage.instance.set("esitqapp-subdomain", user.subdomain);
      OfflineStorage.instance.set(
        "esitqapp-default-permissions",
        user.default_permissions
      );
      OfflineStorage.instance.set(
        "esitqapp-is-root-agency",
        user.is_root_agency
      );
      OfflineStorage.instance.set("esitqapp-user-id", user.user_id);
      OfflineStorage.instance.set("esitqapp-agency-id", user.agency_id);
      OfflineStorage.instance.set(
        "esitqapp-agency-balance",
        user.agency_balance
      );
      OfflineStorage.instance.set("esitqapp-agency-credit", user.agency_credit);
      OfflineStorage.instance.set(
        "esitqapp-agency-percentage",
        user.agency_percentage
      );

      OfflineStorage.instance.set("esitqapp-agency-profit", user.agency_profit);
      OfflineStorage.instance.set(
        "esitqapp-system-currency",
        user.system_currency
      );
      OfflineStorage.instance.set("esitqapp-max-discount", user.max_discount);
      OfflineStorage.instance.set(
        "esitqapp-can-do-minus-sales",
        user.can_do_minus_sales
      );
      OfflineStorage.instance.set("esitqapp-is-debt-ok", user.is_debt_ok);
      OfflineStorage.instance.set(
        "esitqapp-max-inactivity-duration",
        user.max_inactivity_duration
      );
      OfflineStorage.instance.set("esitqapp-livechat-id", user.live_chat_id);
      OfflineStorage.instance.set(
        "esitqapp-is-super-admin",
        user.is_super_admin
      );
      OfflineStorage.instance.set(
        "esitqapp-can-see-super-admin-dashboard",
        user.can_see_super_admin_dashboard
      );
      OfflineStorage.instance.set("esitqapp-uistatedata", user.ui_state_data);
      OfflineStorage.instance.set(
        "esitqapp-has-credit-card",
        user.has_credit_card
      );
      return { ...state, user: user };
    case LOGOUT_USER:
      return { ...state };
    case LOGOUT_USER_SUCCESS:
      OfflineStorage.instance.removeAll();
      return { ...state, user: null };
    case SET_AGENCY_BALANCE:
      const balance = action.payload,
        userCopy = { ...state.user };
      userCopy.agency_balance = balance;
      OfflineStorage.instance.set(
        "esitqapp-agency-balance",
        userCopy.agency_balance
      );
      return { ...state, user: userCopy };
    case SET_AGENCY_CREDIT:
      const credit = action.payload,
        userCopy2 = { ...state.user };
      userCopy2.agency_credit = credit;
      OfflineStorage.instance.set(
        "esitqapp-agency-credit",
        userCopy2.agency_credit
      );
      return { ...state, user: userCopy2 };
    case SET_AGENCY_PERCENTAGE:
      const percentage = action.payload,
        userCopy3 = { ...state.user };
      userCopy3.agency_percentage = percentage;
      OfflineStorage.instance.set(
        "esitqapp-agency-percentage",
        userCopy3.agency_percentage
      );
      return { ...state, user: userCopy3 };
    case SET_AGENCY_PROFIT:
      const profit = action.payload,
        userCopy4 = { ...state.user };
      userCopy4.agency_profit = profit;
      OfflineStorage.instance.set(
        "esitqapp-agency-profit",
        userCopy4.agency_profit
      );
      return { ...state, user: userCopy4 };
    case SET_AGENCY_INFO:
      const agencyInfo = action.payload,
        userCopy5 = { ...state.user };
      userCopy5.agency_profit = agencyInfo.profit;
      userCopy5.agency_percentage = agencyInfo.percentage;
      userCopy5.agency_credit = agencyInfo.credit;
      userCopy5.agency_balance = agencyInfo.balance;
      userCopy5.agency_approved_health = agencyInfo.agency_approved_health;
      userCopy5.agency_approved_travel = agencyInfo.agency_approved_travel;
      userCopy5.agency_priceset_kasko = agencyInfo.agency_priceset_kasko;
      userCopy5.agency_priceset_traffic = agencyInfo.agency_priceset_traffic;
      userCopy5.agency_priceset_dask = agencyInfo.agency_priceset_dask;
      userCopy5.agency_waitingpricing_dask =
        agencyInfo.agency_waitingpricing_dask;
      userCopy5.agency_waitingpricing_traffic =
        agencyInfo.agency_waitingpricing_traffic;
      userCopy5.agency_waitingpricing_kasko =
        agencyInfo.agency_waitingpricing_kasko;
      OfflineStorage.instance.set(
        "esitqapp-agency-profit",
        userCopy5.agency_profit
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-percentage",
        userCopy5.agency_percentage
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-credit",
        userCopy5.agency_credit
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-balance",
        userCopy5.agency_balance
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-approved-health",
        userCopy5.agency_approved_health
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-approved-travel",
        userCopy5.agency_approved_travel
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-waitingpricing-kasko",
        userCopy5.agency_waitingpricing_kasko
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-waitingpricing-traffic",
        userCopy5.agency_waitingpricing_traffic
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-waitingpricing-dask",
        userCopy5.agency_waitingpricing_dask
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-priceset-kasko",
        userCopy5.agency_priceset_kasko
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-priceset-traffic",
        userCopy5.agency_priceset_traffic
      );
      OfflineStorage.instance.set(
        "esitqapp-agency-priceset-dask",
        userCopy5.agency_priceset_dask
      );
      return { ...state, user: userCopy5 };
    case SET_USER_UI_STATE_DATA:
      console.log("setting auth reducer ui state data ...");
      const uiData = action.payload,
        userCopyy = { ...state.user };
      userCopyy.ui_state_data = uiData;
      OfflineStorage.instance.set(
        "esitqapp-uistatedata",
        userCopyy.ui_state_data
      );
      return { ...state, user: userCopyy };
    case SET_USER_UI_STATE_SECTION_COLUMNS:
      console.log("setting auth reducer ui state data ...");
      const userCopyyY = { ...state.user };
      userCopyyY.ui_state_data[action.payload.section]["columns"] =
        action.payload.columns;
      //set localstorage
      OfflineStorage.instance.set(
        "esitqapp-uistatedata",
        userCopyyY.ui_state_data
      );
      //return state
      return { ...state, user: userCopyyY };
    default:
      return { ...state };
  }
};
